import React, { useEffect } from 'react';
import CustomButton from 'components/common/custom-button';
import Input from 'components/input';
import Select from 'components/select';

const BackupForm = ({ areaCodeArr, formikProps, isLoading, get2fadata, mobile }) => {
  const { values, handleChange, handleBlur, errors, touched, setFieldValue } = formikProps;

  useEffect(() => {
    const { backup_2fa_area_code, backup_2fa_phone } = get2fadata;
    setFieldValue('backup_2fa_area_code', backup_2fa_area_code);
    setFieldValue('backup_2fa_phone', backup_2fa_phone);
  }, [get2fadata]);

  return (
    <div className="d-flex">
      <div style={{ width: mobile ? '270px' : '360px', display: 'flex', zIndex: 10000 }}>
        <Select
          options={areaCodeArr || []}
          name={'backup_2fa_area_code'}
          value={values['backup_2fa_area_code']}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['backup_2fa_area_code']}
          touched={touched['backup_2fa_area_code']}
        />
        <Input
          styling={{ marginTop: '-6px', marginLeft: '10px', width: '100%' }}
          name={'backup_2fa_phone'}
          value={values['backup_2fa_phone']}
          onChange={(event) => {
            const numericValue = event.target.value.replace(/[^0-9]/g, '');
            setFieldValue('backup_2fa_phone', numericValue);
          }}
          onBlur={handleBlur}
          error={errors['backup_2fa_phone']}
          touched={touched['backup_2fa_phone']}
          placeholderClass
        />
      </div>
      <CustomButton
        type="submit"
        buttonStyles={{ height: '49px', padding: '0 21px', marginLeft: '10px', marginTop: '20px' }}
        isLoading={isLoading}
      />
    </div>
  );
};

export default BackupForm;
